export enum CommonModalContentTypeEnum {
    SECOND_SCHOOL_CONFIRM,
    ADD_NEW_USER,
    CHANGE_MAIL_ADDRESS,
    DISPLAY_TEXT,
    START_PAID_PLAN,
}